import Api from "../apiService";

class tripsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/trips`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, tripId) {
    return Api.getRequest(
      `companies/${companyId}/trips/${tripId}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, tripData) {
    return Api.postRequest(
      `companies/${companyId}/trips`,
      tripData,
      Api.authHeaders()
    );
  }

  update(companyId, tripId, tripData) {
    return Api.patchRequest(
      `companies/${companyId}/trips/${tripId}`,
      tripData,
      Api.authHeaders()
    );
  }

  delete(companyId, tripId) {
    return Api.deleteRequest(
      `companies/${companyId}/trips/${tripId}`,
      Api.authHeaders()
    );
  }

  forceFetchTripData(companyId, tripId) {
    return Api.postRequest(
      `companies/${companyId}/trips/${tripId}/force_fetch_glonasssoft_datum`,
      {},
      Api.authHeaders()
    );
  }

  createTripFromOrder(companyId, orderData) {
    return Api.postRequest(
      `companies/${companyId}/trips/create_from_order`,
      orderData,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/trips/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/trips/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }

  export(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/trips/export`,
      params,
      Api.authHeaders(),
      { responseType: "blob" } // важно для получения файла
    );
  }

  duplicate(companyId, id, params = {}) {
    return Api.postRequest(
      `companies/${companyId}/trips/${id}/duplicate`,
      params,
      Api.authHeaders()
    );
  }
}

export default new tripsApi();
